var ajax_module_process = false;

// Skeleton card grid injected into a .lazy-module the moment it becomes visible.
// The matching CSS lives in custom.scss (.lazy-skeleton / .lazy-skeleton-card).
// $(this).load() overwrites innerHTML on success, so the skeleton naturally
// disappears when the real content arrives.
var LAZY_SKELETON_HTML = '<div class="lazy-skeleton" aria-hidden="true">' +
    '<div class="lazy-skeleton-card"></div>'.repeat(4) +
    '</div>';

$(window).scroll(function () {
    $('.lazy-module').each(function () {
        if (!isElementVisible($(this), $(window))) return;

        // Inject the skeleton on first visibility, before AJAX even fires.
        // This way the user sees a loading placeholder even while other
        // lazy-modules are still being fetched serially.
        if ($(this).is(':empty')) {
            $(this).html(LAZY_SKELETON_HTML);
        }

        if (ajax_module_process !== false) return;
        ajax_module_process = true;

        var url = false;
        if ($(this).hasClass('lazy-related')) {
            url = 'index.php?route=product/product/related_products&product_id=' + $(this).data('product-id');
        } else if ($(this).hasClass('lazy-similar')) {
            url = 'index.php?route=product/product/similar_products&product_id=' + $(this).data('product-id');
        } else {
            let product_id = 0;
            const productPageProductIdSelector = $('input[name="product_id"]');
            if (productPageProductIdSelector.length) {
                product_id = productPageProductIdSelector.val();
            }
            url = 'index.php?route=extension/lazymodule&code=' + $(this).data('code') + '&product_id=' + product_id;
        }

        $(this).load(url, function () {
            $(this).removeClass('lazy-module');
            window.initSwipers();
            ajax_module_process = false;
            // Kick the scan again so a sibling lazy-module already in view
            // starts loading immediately, without needing another scroll tick.
            $(window).trigger('scroll');
        });
    });
});
